import { Link, Typography } from '@mui/material';
import { Box, BoxProps } from '@mui/system';
import { format } from 'date-fns';

import { useMatchsPlannerContext } from './MatchsPlannerContext';

type MatchsPlannerEmptyProps = BoxProps & { withCta: boolean };

export const MatchsPlannerEmpty = ({
  withCta,
  sx = {},
  ...rest
}: MatchsPlannerEmptyProps) => {
  const context = useMatchsPlannerContext();

  // On n'affiche rien si les matchs n'ont pas encore été chargés
  // ou qu'il y a des matchs dans le tableau
  if (context.events?.length !== 0) {
    return null;
  }

  return (
    <Box
      sx={{
        ...sx,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '20rem',
      }}
      {...rest}
    >
      <Typography
        variant="h5"
        component="p"
        align="center"
        sx={{ mb: 2, fontStyle: 'unset' }}
      >
        Aucun match trouvé
        <br />
        du {format(context.startDate, 'dd/MM/yy')} au{' '}
        {format(context.endDate, 'dd/MM/yy')} <span role="img">😮</span>
      </Typography>

      {withCta && (
        <Link
          underline="always"
          href="mailto:contact@scorenco.com?subject=SUPPORT%20:%20[PLANIFICATEUR]%20Match(s)%20manquant(s)"
          target="_BLANK"
          sx={{
            fontSize: '0.8rem',
            textAlign: 'center',
            width: 'fit-content',
          }}
        >
          Signaler une erreur
        </Link>
      )}
    </Box>
  );
};
